import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import AutoTips from '@/components/AutoTips/index.vue';

export default {
  components: {
    AutoTips: AutoTips
  },

  props: {
    switchName: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    mwConfig: function mwConfig(state) {
      return state.creative.template.templateConfig.mw_config;
    }
  }), {
    title: function title() {
      return this.$t('playTurbo.gamePlay.' + this.switchName + '.name');
    },
    desc: function desc() {
      return this.$t('playTurbo.gamePlay.' + this.switchName + '.desc');
    },


    model: {
      get: function get() {
        return this.mwConfig[this.switchName];
      },
      set: function set(val) {
        this.$store.commit('creative/template/updateMwConfig', _defineProperty({}, this.switchName, val));
        // 打开总开关，将其关联的子开关的值全部还原为原始的值
        if (val === 1) {
          this.updateRefGameConfig(this.switchName);
        }
      }
    }
  }),

  methods: {
    updateRefGameConfig: function updateRefGameConfig(switchName) {
      this.$store.dispatch('creative/template/updateRefGameConfig', switchName);
    }
  }
};